import { SellerApiMoySklad } from 'components/sellers/SellerApiMoySklad/SellerApiMoySklad'
import { useAppSelector } from 'shared/hooks/useReduxHooks'
import { appSelectors } from 'store/app'

export const ProfileApiMoySklad: React.FC = () => {
  const sellerId = useAppSelector(appSelectors.selectSellerId)
  return <SellerApiMoySklad type='profile' sellerId={sellerId ?? ''} />
}